import { render, staticRenderFns } from "./Bookmarks.vue?vue&type=template&id=74de8b16&"
import script from "@/components/bookmarks/Bookmarks.ts?vue&type=script&lang=ts&"
export * from "@/components/bookmarks/Bookmarks.ts?vue&type=script&lang=ts&"
import style0 from "@/components/bookmarks/bookmarks.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports